import { useEffect } from "react"
import { Link } from "react-router-dom"
import { useLogoutUserMutation } from "../app/authApiSlice"

const LoggedOutPage = () => {
  const [logoutUser] = useLogoutUserMutation()

  useEffect(() => {
    const logout = async () => {
      try {
        await logoutUser().unwrap()
      } catch (logoutError) {
        console.error("Logout failed:", logoutError)
      }
    }

    logout()
  }, [logoutUser])

  return (
    <div className="text-center pt-5">
      <h1 className="mb-4 mt-5 fs-2 fw-semibold">An error has occured</h1>
      <p>You have been logged out. Please log in again to continue.</p>
      <Link to="/login" className="btn btn-dark rounded-3 px-4 mt-3">
        Go to Login
      </Link>
    </div>
  )
}

export default LoggedOutPage
